function WEFIntro({ Attendee, allWEFComplete }) {
  return (
    <div className="welcome-message">
      <h1 className={window.innerWidth <= 768 ? "mobile-heading" : ""}>
        Welcome {Attendee.BasicInfo?.First_Name} to the Parent/Student Portal
      </h1>
      <p className={window.innerWidth <= 768 ? "mobile-paragraph" : ""}>
        InvestIN has a duty of care to safeguard and support all students
        attending an InvestIN programme. The purpose of this form is for
        InvestIN to have an awareness of every student and support their needs
        as much as possible. All information on this form will be handled by
        InvestIN with the utmost discretion and in accordance with our privacy
        policy which you can find{" "}
        <a href="https://investin.org/pages/privacy-policy" target="_blank">
          <strong>here.</strong>
        </a>
        <br></br> <br></br>
        If you have any questions, please contact us at info@investin.org, or
        through your InvestIN contact.
        <br></br> <br></br>
        <strong>Your Programme: </strong>{" "}
        {Attendee && Attendee.BasicInfo && Attendee.BasicInfo.ProgrammeTitle
          ? Attendee.BasicInfo.ProgrammeTitle
          : ""}
        <br></br>
        <strong>Date of Programme: </strong>{" "}
        {Attendee && Attendee.BasicInfo && Attendee.BasicInfo.ProgrammeDate
          ? Attendee.BasicInfo.ProgrammeDate
          : ""}
        <br></br>
        <strong>Programme Variant: </strong>{" "}
        {Attendee && Attendee.BasicInfo && Attendee.BasicInfo.ProgrammeVarient
          ? Attendee.BasicInfo.ProgrammeVarient
          : ""}
        <br></br>
        <br></br>
        <br></br>
        {allWEFComplete && (
          <div className="all-Complete">
            <strong>✅All Forms Complete !✅</strong>
            <br></br>
            If any of your information changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </div>
        )}
      </p>
    </div>
  );
}

export default WEFIntro;
